export const DEFAULT_DOCUMENT_TITLE = "Omer Yoachimik";
export const EXPERIENCE_DOCUMENT_TITLE = "Omer Yoachimik - Experience";
export const SCHEDULE_DOCUMENT_TITLE = "Schedule a call - Omer Yoachimik";

function normalisePathname(pathname: string): string {
  return pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
}

export function isExperiencePath(pathname: string): boolean {
  return normalisePathname(pathname) === "/experience";
}

export function documentTitleForPath(pathname: string): string {
  if (normalisePathname(pathname) === "/schedule") return SCHEDULE_DOCUMENT_TITLE;
  return isExperiencePath(pathname)
    ? EXPERIENCE_DOCUMENT_TITLE
    : DEFAULT_DOCUMENT_TITLE;
}
